import React, { Component } from 'react'

class SubNav extends Component {
  render () {
    const { title, children, className } = this.props
    return (
      <div className={className || 'Navbar__item__dropdown'}>
        {title ? (
          <span className='title' style={{ whiteSpace: 'nowrap' }}>
            {title}
          </span>
        ) : null}
        {children ? <div className='list'>{children}</div> : null}
      </div>
    )
  }
}

export default SubNav
